import { render } from "./v-loader-animation.vue?vue&type=template&id=5e408c16&ts=true"
import script from "./v-loader-animation.vue?vue&type=script&lang=ts"
export * from "./v-loader-animation.vue?vue&type=script&lang=ts"

import "./v-loader-animation.vue?vue&type=style&index=0&id=5e408c16&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__